import styled from 'styled-components'
import { Checkbox } from 'antd'
import { IndexedLotAvailability } from 'types'
import Spacer from './Spacer'
import { useEffect, useState } from 'react'
import i18n from 'translations/i18n'
import SortButton from './SortButton'
// import { CheckOutlined } from '@ant-design/icons'

export default function LongLotsComponent(props: {
  sortBatch: number
  sortLot: number
  sortMeter: number
  checkboxList: Number[]
  defaultAvailability: boolean
  sortedLotAvailability: IndexedLotAvailability[]
  handleClickCheckbox: (indexedLot: IndexedLotAvailability, check: boolean) => void
  handleSortBatch: React.Dispatch<React.SetStateAction<number>>
  handleSortLot: React.Dispatch<React.SetStateAction<number>>
  handleSortMeter: React.Dispatch<React.SetStateAction<number>>
}) {
  useEffect(() => {
    setLotAvailability(props.sortedLotAvailability)
    return () => {
      setLotAvailability(undefined)
      props.handleSortLot(0)
      props.handleSortBatch(0)
      props.handleSortMeter(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  enum KEY {
    BATCH = 'batch',
    LOT = 'lot',
    METER = 'meter',
  }

  enum SORT {
    DEFAULT = 0,
    ASC = 1,
    DESC = 2,
  }

  const [lotAvailability, setLotAvailability] = useState<IndexedLotAvailability[] | undefined>(undefined)

  const changeStatus = (newStatus: number, sortingKey: string): void => {
    switch (sortingKey) {
      case KEY.BATCH:
        props.handleSortBatch(newStatus)
        props.handleSortLot(0)
        props.handleSortMeter(0)
        break
      case KEY.LOT:
        props.handleSortBatch(0)
        props.handleSortLot(newStatus)
        props.handleSortMeter(0)
        break
      case KEY.METER:
        props.handleSortBatch(0)
        props.handleSortLot(0)
        props.handleSortMeter(newStatus)
    }
    sortArray(newStatus, sortingKey)
  }

  const sortArray = (newStatus: number, sortingKey: string) => {
    switch (newStatus) {
      case SORT.ASC:
        setLotAvailability(sortByKeyASC(lotAvailability!, sortingKey))
        break
      case SORT.DESC:
        setLotAvailability(sortByKeyDESC(lotAvailability!, sortingKey))
        break
      case SORT.DEFAULT:
        setLotAvailability(props.sortedLotAvailability)
    }
  }

  const sortByKeyASC = (indexedLots: IndexedLotAvailability[], sortingKey: string): IndexedLotAvailability[] => {
    return indexedLots.sort(function (a, b) {
      const x = a[sortingKey]
      const y = b[sortingKey]
      return x < y ? -1 : x > y ? 1 : 0
    })
  }

  const sortByKeyDESC = (indexedLots: IndexedLotAvailability[], sortingKey: string): IndexedLotAvailability[] => {
    return indexedLots.sort(function (a, b) {
      const x = a[sortingKey]
      const y = b[sortingKey]
      return x > y ? -1 : x < y ? 1 : 0
    })
  }

  return (
    <>
      <HeadersContainer>
        <HeaderCol>
          <BatchHeader>
            {i18n.t('availabilityPage.sub_drawer_1.subtitle_1')}
            <SpaceDetail />
            <SortButton sortState={props.sortBatch} sortingKey={KEY.BATCH} onChangeSortState={changeStatus} />
          </BatchHeader>
        </HeaderCol>
        {/* <HeaderCol>
          <SupportHeader>
            {i18n.t('availabilityPage.sub_drawer_1.column_support')}
          </SupportHeader>
        </HeaderCol> */}
        <HeaderCol>
          <LotHeader>
            {i18n.t('availabilityPage.sub_drawer_1.subtitle_2')}
            <SpaceDetail />
            <SortButton sortState={props.sortLot} sortingKey={KEY.LOT} onChangeSortState={changeStatus} />
          </LotHeader>
        </HeaderCol>
        <HeaderCol>
          <MeterHeader>
            {i18n.t('availabilityPage.sub_drawer_1.subtitle_3')}
            <SpaceDetail />
            <SortButton sortState={props.sortMeter} sortingKey={KEY.METER} onChangeSortState={changeStatus} />
          </MeterHeader>
        </HeaderCol>
      </HeadersContainer>

      <Spacer />
      <Spacer />
      <Spacer />
      <Spacer />
      <Scrollbar>
        {props.sortedLotAvailability &&
          !props.defaultAvailability &&
          lotAvailability?.map((indexedLot, index) => (
            <div key={index} style={{ display: 'inline-flex', lineHeight: '2' }}>
              <HeaderCheckbox
                checked={props.checkboxList.includes(indexedLot.index)}
                onChange={(e) => props.handleClickCheckbox(indexedLot, e.target.checked)}
                placeholder="default size"
              />
              <RowDetails>
                <SpaceDetail />
                {/* <Tooltip
                      placement="topLeft"
                      title={n.batch ? n.batch : '------'}
                      overlayInnerStyle={{ fontSize: '1vw' }}
                      > */}
                <BatchDetail>{indexedLot.batch ? indexedLot.batch : '------'}</BatchDetail>
                {/* </Tooltip> */}
                {/* <SupportDetail>{indexedLot.support.match("R01") ? <CheckOutlined /> : "---"}</SupportDetail> */}
                <LotDetail>{indexedLot.lot}</LotDetail>
                <MetersDetail>{Number(indexedLot.meter).toFixed(2)}m</MetersDetail>
              </RowDetails>
            </div>
          ))}
        {props.defaultAvailability &&
          lotAvailability?.map((indexedLot, index) => (
            <div key={index} style={{ display: 'inline-flex', lineHeight: '2' }}>
              <HeaderCheckbox
                checked={props.checkboxList.includes(indexedLot.index)}
                onChange={(e) => props.handleClickCheckbox(indexedLot, e.target.checked)}
                placeholder="default size"
              />
              <RowDetails>
                <SpaceDetail />
                <BatchDetail>{indexedLot.batch ? indexedLot.batch : '------'}</BatchDetail>
                {/* <SupportDetail>{indexedLot.support.match('R01') ? <CheckOutlined /> : '---'}</SupportDetail> */}
                <LotDetail>{indexedLot.lot}</LotDetail>
                <MetersDetail>{Number(indexedLot.meter).toFixed(2)}m</MetersDetail>
              </RowDetails>
            </div>
          ))}
      </Scrollbar>
    </>
  )
}

const HeadersContainer = styled.div`
  width: 30.5vw;
  height: 2vh;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-left: 1vw;
  margin-bottom: 1vw;
`

const HeaderCol = styled.div`
  margin: auto;
  /* width: 9vw; */
  /* Sans/Body/Semibold */
  font-family: Rajdhani;
  font-style: normal;
  font-weight: 600;
  font-size: 1.4vw;
  line-height: 1.2;
  text-align: center;
`

const BatchHeader = styled.div`
  width: 11.5vw;
  display: flex;
  justify-content: flex-start;
  /* Main/Darker */
  color: #774a28;
`

// const SupportHeader = styled.div`
//   color: #ab7f47;
//   text-align: center;
// `

const LotHeader = styled.div`
  width: 11.5vw;
  display: flex;
  justify-content: center;
  /* Neutral/Grey */
  color: #a1a2aa;
`

const MeterHeader = styled.div`
  width: 6.5vw;
  display: flex;
  justify-content: center;
  /* Neutral/Black */
  color: #28293d;
`

const Scrollbar = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 52vh;
  width: 34vw;
  border-bottom: 1px solid #c1c1c1;

  font-family: Rajdhani;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2vw;
  color: #28293d;
`

const RowDetails = styled.div`
  width: 30.5vw;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

const HeaderCheckbox = styled(Checkbox)`
  width: 1vw;
  align-self: center;
`

const BatchDetail = styled.p`
  width: 11.5vw;
  flex: 1;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 0.5vw;
`

// const SupportDetail = styled.p`
//   width: 2vw;
//   display: flex;
//   justify-content: center;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   margin-left: 1vw;
// `

const LotDetail = styled.p`
  width: 11.5vw;
  display: flex;
  justify-content: center;
  overflow-wrap: anywhere;
  text-align: center;
  margin-left: 1vw;
`

const MetersDetail = styled.p`
  width: 6.5vw;
  display: flex;
  justify-content: center;
  overflow-wrap: anywhere;
`

const SpaceDetail = styled.p`
  width: 0.5vw;
`
